/**
* @file 系统设置-短信管理-短信记录
* */
<template>
  <div id="smsRecord">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :has-organization="true"
       labelWidth="135">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'createTime'">{{
          row.createTime | filterTime
        }}</template>
        <template v-else-if="item.prop === 'status'">
          <el-tag size="small" :type="row.status | filterConst('SMSSTATUS', 'type')">{{ row.status | filterConst('SMSSTATUS') }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'type'">{{
          row.type === 1 ? "验证码" : "通知"
        }}</template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <!--创建提成规则弹框-->
    <el-dialog title="短信群发" :visible.sync="visible" width="360px" :close-on-click-modal="false">
      <p style="padding-bottom: 16px" class="util-remark">
        审核通过的司机，才会收到群发短信
      </p>
      <el-form :model="form" :rules="rules" ref="form" label-width="auto">
        <el-form-item class="line-fee" label="群发范围" prop="organizationId">
          <el-select v-model="form.organizationId" filterable
            v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
            <el-option value="" label="全部机构名称"></el-option>
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{
            organizations && organizations[0] && organizations[0].name
          }}</span>
        </el-form-item>
        <el-form-item label="" prop="message">
          <el-input v-model="form.message" type="textarea" maxlength="100" placeholder="请输入要群发的内容，1-100字"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveClick" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "smsRecord",
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      rules: {
        message: [{ required: true, message: "请输入要群发的内容" }],
      },
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/sms/record",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "datetime", field: "time", name: "发送时间", value: [] },
        ],
      },
      // 表头
      columns: [
        { prop: "phone", label: "电话", width: "100" },
        { prop: "status", label: "状态", width: "90" },
        { prop: "cost", label: "扣除记录数", width: "90" },
        { prop: "reason", label: "失败原因", width: "100" },
        { prop: "type", label: "类型", width: "60" },
        { prop: "message", label: "消息" },
        { prop: "createTime", label: "发送时间", width: "200" },
      ],
    };
  },
  methods: {
    async addFn() {
      await this.mixinOrganizations();
      this.visible = true;
      if (this.mixinUserInfo && this.mixinUserInfo.organizationType === 2) {
        if (
          this.organizations &&
          this.organizations[0] &&
          this.organizations[0].id
        ) {
          this.$set(this.form, "organizationId", this.organizations[0].id);
        }
      } else {
        this.$set(this.form, "organizationId", "");
      }
    },
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let url = "/api/v1/manage/sms/batch";
          let params = this.$utils.deepCopyFn(this.form);
          params.type = 2;
          let data = await this.$axios.post(url, params);
          this.loading = false;
          if (data && data.code === 1) {
            this.visible = false;
            this.$message.success("操作成功");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
#smsRecord {
  height: 100%;
}
</style>
